import * as type from './types';
import { createReducer } from "../../util/index";

const initialState = {};

const ongoingReducer = createReducer(initialState) ({
    [type.LIST]: (state, action) => ({
        ...state,
        rs: action.value, 
    }),
});

export default ongoingReducer;